import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';

export interface SetToMigratedRegion {
    value: string;
    display: string;
    disabled: boolean;
}

export interface SetToMigratedDialogData {
    storeId: string;
    regions: SetToMigratedRegion[];
    selectedRegion?: string | null;
}

@Component({
    template: `
        <h2 mat-dialog-title>Set this store as Migrated</h2>
        <mat-dialog-content>
            <p><strong>Warning:</strong> Do it when once the migration is done and has been validate on the store in the new region.</p>
            <p>Pick the target migration region for <code>{{ data.storeId }}</code>.</p>
            <mat-form-field>
                <mat-label>Region</mat-label>
                <mat-select name="migratedToRegion" required [(ngModel)]="selectedRegion">
                    @for (entry of data.regions; track entry.value) {
                        <mat-option [value]="entry.value" [disabled]="entry.disabled">{{ entry.display }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button mat-dialog-close>Cancel</button>
            <button mat-raised-button color="warn" [mat-dialog-close]="selectedRegion" [disabled]="!selectedRegion">
                Set as Migrated
            </button>
        </mat-dialog-actions>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, MatFormField, MatLabel, MatSelect, MatOption, FormsModule, MatDialogActions, MatButton, MatDialogClose]
})

export class SetToMigratedDialogComponent {
    data = inject<SetToMigratedDialogData>(MAT_DIALOG_DATA);
    selectedRegion: string | undefined = this.data.selectedRegion ?? undefined;
}

